import React from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const featureDetails = {
  "Innovation": {
    title: 'Innovation',
    image: '/images/sap-implementation.jpg',
    description: "At SSNM3 Technologies, innovation isn’t just a buzzword—it’s our foundation. We are driven by a relentless curiosity and a commitment to pushing boundaries. Our mission is to create intelligent, impactful solutions that reshape industries and empower people.",
    description1: "Our innovations reflect not only our technical expertise but also our deep understanding of the real-world challenges our clients face. Through continuous R&D, agile development, and a culture that values bold thinking, SSNM3 Technologies is consistently ahead of the curve—delivering smart, future-ready solutions that make a difference."
  },
  "Experience": {
    title: 'Experience',
    image: '/images/sap-integration.jpg',
    description: "SSNM3 Technologies has team of professionals with more than 10 years of experience in implementing Infor applications M3 multi-tenant cloud suite, Factory Track and Optiva PLM to various industries. We help organizations to understand industry leading business practices around various platform integrations.",
    description1: ""
  },
  "Quality": {
    title: 'Quality',
    image: '/images/sap-integration.jpg',
    description: "At SSNM3 Technologies, quality is more than a standard—it’s a mindset woven into every step of our process. We believe that delivering exceptional solutions begins with an unwavering commitment to precision, performance, and continuous improvement.From concept to deployment, every product and service we offer is backed by rigorous quality control protocols, industry best practices, and a culture that values craftsmanship. Our teams are empowered to challenge the status quo, optimize systems, and ensure that every output reflects our core promise: reliability you can trust, innovation you can count on.",
    description1: "We align closely with our clients’ goals, ensuring that our solutions don’t just meet expectations—they exceed them. Whether it’s through compliance with global standards, transparent communication, or user-centric design, SSNM3 Technologies is dedicated to delivering quality that lasts. Because to us, quality isn’t a checkbox—it’s our reputation."
  }
};

const Feature = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const feature = featureDetails[id];

  if (!feature) return <Typography>Feature not found.</Typography>;

  return (
    <Container maxWidth="false" className='service-container'>
        <Box className='service-sub-container'>
            <Paper elevation={3}>
                {/* Top Image */}
                <Box className='feature-detail' />

                {/* Content */}
                <Box p={3} className='feature-body'>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBack />}
                        onClick={() => navigate(-1)} // Goes to previous page
                        sx={{ mb: 2 }}
                    >
                        Back to Features
                    </Button>
                    <Typography variant="h4" gutterBottom>
                        {feature.title}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                        {feature.description}
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                        {feature.description1}
                    </Typography>
                </Box>
            </Paper>
        </Box>
    </Container>
  );
};

export default Feature;
